import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('circles', 'remove-guardian-role');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'guardians_proxies',
    {
      type: 'payload',
      selector: ['memberId'],
    },
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/circles/remove-guardian-role.js